export default __webpack_public_path__ + "static/media/markLine.e2f43003.svg";